import React from "react";
import styled from "styled-components";
import { read_timeline_value_label } from "../../../utils/timeline/timeline_formatting";
import { Timeline_Sales_Session_Change } from "./Timeline_Sales_Session_Change";
import { read_sales_session_change } from "./sales_session_view";

const TimelineSalesChanges = styled.div`
    display: grid;
    gap: 0.35rem;
`;

const TimelineSalesRoleTransition = styled.p`
    display: flex;
    align-items: baseline;
    flex-wrap: wrap;
    gap: 0.35rem;

    span:first-child {
        color: var(--greyDark);
    }

    span:nth-child(2) {
        color: ${p => p.theme.mid};
    }

    strong {
        color: ${p => p.theme.color};
    }
`;

// Reads a saved caller or contract seller as a person's full display name.
const read_sales_person_name = (change) => {
    const normalizedChange = read_sales_session_change(change);
    const value = normalizedChange.to ?? normalizedChange.from;
    const structuredName = value && typeof value === "object"
        ? [value.firstName || value.firstname, value.lastName || value.lastname].filter(Boolean).join(" ")
        : "";
    const savedName = value && typeof value === "object"
        ? value.name || value.label || value.displayName || structuredName || value
        : value;

    return read_timeline_value_label(savedName);
};

// Uses the completed session owner when legacy SASS rows copied the new seller into both roles.
const read_sales_caller_change = (event, callerChange) => {
    const sessionSeller = event?.sessionSeller;
    const hasSessionSeller = typeof sessionSeller === "string"
        ? Boolean(sessionSeller.trim())
        : Boolean(sessionSeller && Object.keys(sessionSeller).length);

    return hasSessionSeller ? { field: "caller", to: sessionSeller } : callerChange;
};

// Displays every field edit bundled into one Sales-session scenario.
export const Timeline_Sales_Session_Changes = (props) => {
    const fieldChanges = props.event.fieldChanges || [];
    const fieldNames = fieldChanges.map((change) => `${change?.field || ""}`.trim().toLowerCase());
    const hasCallerTransition = fieldNames.includes("caller") && fieldNames.includes("contractseller");
    const callerChange = fieldChanges.find((change) => `${change?.field || ""}`.trim().toLowerCase() === "caller");
    const contractSellerChange = fieldChanges.find((change) => `${change?.field || ""}`.trim().toLowerCase() === "contractseller");
    const visibleCallerChange = read_sales_caller_change(props.event, callerChange);
    const visibleFieldChanges = hasCallerTransition
        ? fieldChanges.filter((change) => !["caller", "contractseller"].includes(`${change?.field || ""}`.trim().toLowerCase()))
        : fieldChanges;

    if (!visibleFieldChanges.length && !hasCallerTransition) {
        return null;
    }

    return (
        <TimelineSalesChanges>
            {visibleFieldChanges.map((change, index) => (
                <Timeline_Sales_Session_Change
                    key={`${props.event.key}-${change?.field || index}`}
                    change={change}
                    t={props.t}
                />
            ))}
            {hasCallerTransition && (
                <TimelineSalesRoleTransition data-testid="timeline-sales-role-transition">
                    <span>{read_sales_person_name(visibleCallerChange)}</span>
                    <span aria-hidden="true">→</span>
                    <strong>{read_sales_person_name(contractSellerChange)}</strong>
                </TimelineSalesRoleTransition>
            )}
        </TimelineSalesChanges>
    );
};
